import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import { Box, Divider } from "@mui/material";
import { apiService } from "constants/axiosInstance";
import { useHistory } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

export default function CustomSeparator({ currentGroup }) {
  const history = useHistory();
  const [dataBreadcrumb, setDataBreadcrumb] = React.useState([]);

  const ellipseString = (str, max) => {
    let res = "";
    for (let i = 0; i < Math.min(str.length, max); i++) {
      res += str[i];
    }
    if (str.length > max) res += "...";
    return res;
  };

  const getCurrentBreadcrumb = async () => {
    let tmp = currentGroup;
    let data = [];
    while (true) {
      data = data.concat(tmp);
      if (tmp?.parent == null) {
        break;
      }
      tmp = tmp.parent;
    }
    let breadcrumbs = [];
    data.reverse();

    breadcrumbs = data.map((item, index) => {
      if (index === 0)
        return (
          <Box
            key={item?.id}
            sx={{ display: "flex", alignItems: "center" }}
            onClick={() => {
              history.push(`/projects?groupID=${item?.id}`);
            }}
          >
            <FolderOpenIcon
              fontSize="small"
              sx={{ mrx: "4px", width: "1.2em", height: "1.2em" }}
            />
            <Typography
              key={item?.id}
              color="text.primary"
              sx={{
                "&": {
                  cursor: "pointer",
                  lineHeight: "22px",
                  fontSize: 15,
                  margin: "0px 10px",
                  padding: "3px 7px",
                  borderRadius: "6px",
                },
                "&:hover": {
                  background: "#0000000a",
                },
              }}
            >
              {Object.keys(item).filter((item) => item === "parent")?.length >
              0 ? (
                ellipseString(item?.name, 20)
              ) : (
                <MoreHorizIcon sx={{ paddingTop: "5px" }} />
              )}
            </Typography>
          </Box>
        );
      return (
        <Typography
          key={item?.id}
          color="text.primary"
          onClick={() => {
            history.push(`/projects?groupID=${item?.id}`);
          }}
          sx={{
            "&": {
              color: index === data.length - 1 ? "#000000DE" : "black",
              cursor: "pointer",
              lineHeight: "22px",
              fontSize: 15,
              margin: "0px 10px",
              padding: "3px 7px",
              borderRadius: "6px",
            },
            "&:hover": {
              // textDecoration: "underline",
              background: "#0000000a",
            },
          }}
          // style={{ color: index === data.length - 1 ? "#CCD0DB" : "black" }}
        >
          {ellipseString(item?.name ?? "", 20)}
        </Typography>
      );
    });
    setDataBreadcrumb(breadcrumbs);
  };

  React.useEffect(() => {
    if (currentGroup) {
      getCurrentBreadcrumb();
    }
  }, [currentGroup]);

  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          borderBottom: "1px solid #ccc",
          margin: "0px 0px 0px",
          paddingBottom: "10px",
          "& .MuiBreadcrumbs-separator": {
            margin: 0,
          },
        }}
      >
        {dataBreadcrumb}
      </Breadcrumbs>
    </Stack>
  );
}
